var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-password-container"},[_c('div',{staticClass:"row mx-0"},[_c('div',{staticClass:"offset-md-1 col-md-6 px-0"},[_c('reset-password-instructions')],1),_c('div',{staticClass:"col-md-5 px-0 faq-container"},[_c('reset-password-faq')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }